import axios from "axios";
import { NULL } from "sass";

export const fetchSupplierProductDetail = (id)=>async(dispatch)=>{
  try {
    const response =await axios.get(`/api/cm-yuva/getsupplierProductDetail?id=${id}`);
    dispatch({
      type: "SUPPLIER_PRODUCT_DETAIL_FULFILLED",
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: "SUPPLIER_PRODUCT_DETAIL_REJECTED",
      payload: e.response,
    });
  }
}

export const fetchSupplierProductList = (supplier_id=null,page, search="",sector= null,industry= null)=>async(dispatch)=>{
    try {
      dispatch({
        type: "SUPPLIER_PRODUCT_LIST_PENDING",
      });
      const response =await axios.get(`/api/cm-yuva/getsupplierProductList?page=${page}${search ? `&search=${search}` : ""}${sector ? `&sector=${sector}` : ""}${industry ? `&industry=${industry}` : ""}${supplier_id ? `&supplier_id=${supplier_id}` : ''}`);
      dispatch({
        type: "SUPPLIER_PRODUCT_LIST_FULFILLED",
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: "SUPPLIER_PRODUCT_LIST_REJECTED",
        payload: e.response,
      });
    }
  }
  export const fetchAuthSupplierProductList = (token, supplier_id = null, page, search = "", sector = null, industry = null,paginate=10) => async (dispatch) => {
    try {
      dispatch({
        type: "SUPPLIER_PRODUCT_LIST_PENDING",
    });
        const response = await axios.get(
            `/api/supplier/getsupplierProductList?page=${page}${search ? `&search=${search}` : ""}${sector ? `&sector=${sector}` : ""}${industry ? `&industry=${industry}` : ""}${supplier_id ? `&supplier_id=${supplier_id}` : ""}${paginate ? `&paginate=${paginate}` : ""}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        dispatch({
            type: "SUPPLIER_PRODUCT_LIST_FULFILLED",
            payload: response?.data,
        });
    } catch (e) {
        dispatch({
            type: "SUPPLIER_PRODUCT_LIST_REJECTED",
            payload: e.response,
        });
    }
};
  export const getSupplierDetails = (supplier_id = null) => async (dispatch) => {
    try {
      dispatch({
        type: "SUPPLIER_DETAILS_PENDING",
    });

        const response = await axios.post(
            `/api/supplier/getsupplierdetails`,
            { supplier_id:supplier_id});
        dispatch({
            type: "SUPPLIER_DETAILS_FULFILLED",
            payload: response?.data,
        });
    } catch (e) {
        dispatch({
            type: "SUPPLIER_DETAILS_REJECTED",
            payload: e.response,
        });
    }
};



  export const fetchSubCategories = (category_id) => async (dispatch) => {
    try {
      dispatch({ type: "SUB_CATEGORIES" });
      const response = await axios.get(`/api/cm-yuva/get-sub-categories?category_id=${category_id}`);
      dispatch({
        type: "SUB_CATEGORIES_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "SUB_CATEGORIES_REJECTED",
        payload: error.response,
      });
    }
  };
